import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { Store } from '@ngrx/store';
import { BaseModalPageComponent } from '../../base-modal.component';
import { ModalComponent } from '../../modal/modal.component';
import { CONFIG } from '../../partsview/store/reducer/config.reducer';
import { DATA } from '../../partsview/store/reducer/data.reducer';
import { resetData } from '../../partsview/store/actions/data.actions';
import { resetBasket } from '../../partsview/store/actions/basket.actions';
import { resetConfig } from '../../partsview/store/actions/config.actions';

@Component({
    selector: 'partsview-modal',
    templateUrl: './partsview-modal.component.html',
    standalone: false
})
export class PartsViewModalComponent extends BaseModalPageComponent {
  uid: string;
  machineSerial: string;
  parts: any;

  constructor(
    public selfModal: ModalComponent,
    location: Location,
    private store: Store<{ data: DATA; config: CONFIG; basket: [] }>
  ) {
    super(location);
  }

  public init(data: any) {
    Object.assign(this, data);
  }

  submit() {
    this.selfModal.close(this.parts);
    this.reset();
  }

  cancel() {
    this.selfModal.close();
    this.reset();
  }

  private reset() {
    this.store.dispatch(resetData());
    this.store.dispatch(resetBasket());
    this.store.dispatch(resetConfig());
  }
}
